import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { Rating } from '@spotahome/ui-library';

import './ReviewsFactor.scss';

const ReviewsAverage = ({ type, rating }) => (
  <div className="reviews-factor">
    <strong className="reviews-factor__label">
      {trans(`reviews.factor.${type}`)}
    </strong>
    <Rating rating={rating} />
  </div>
);

ReviewsAverage.propTypes = {
  type: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired
};

export default ReviewsAverage;
